import React, { useEffect, useRef, useState } from 'react';
import { iconForField } from '../../../../common/custom/icon-library';
import { SketchPicker } from 'react-color';
import { ErrorMessage, Field, getIn } from 'formik';
export const ColorCodeField = ({
  field,
  isConstructorForm,
  setFieldValue,
  values,
  showErrorMsg = true,
}) => {
  const [color, setColor] = useState('');
  const [isPickerDisplay, setIsPickerDisplay] = useState(false);
  // const colorInputRef = useRef(null);

  const handleClickOutside = (event) => {
    // if (colorInputRef.current && !colorInputRef.current.contains(event.target)) {
    //   setIsPickerDisplay(false);
    // }
    if (!event.target.closest('.color-picker-popover')) {
      setIsPickerDisplay(false);
    }
  };

  const handleChange = (values) => {
    setColor(values.hex);
    setFieldValue(field.fieldName, values.hex);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let colorFieldValue = getIn(values, field.fieldName);
    colorFieldValue = colorFieldValue ? colorFieldValue : '';
    // handleChange({ hex: colorFieldValue });
    setColor(colorFieldValue);
  }, [values]);

  const validate = (value) => {
    let error = '';
    if (showErrorMsg) {
      const hexColorRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
      const isColorCode = hexColorRegex.test(value);
      if (!isColorCode) error = 'Please Add a validate hex color code.';
    }
    return error;
  };

  return (
    <>
      {/* <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12" ref={colorInputRef}>
        <div className="form-group summernote-custom-css">
          <div className="input-group">
            <div className="input-group-prepend" title={field.fieldTitle['en']}>
              <span className="input-group-text">
                <i className={`wb ${iconForField(field.type)}`}></i>
                <span className="required">{field.required && !isConstructorForm ? ' *' : ''}</span>
              </span>
            </div> */}
      <Field
        type={'text'}
        name={field.fieldName}
        className="form-control form-control-sm"
        validate={validate}
        placeholder={field.placeholder['en']}
        title={field.fieldTitle['en']}
        onClick={() => setIsPickerDisplay(true)}
      />
      {showErrorMsg && (
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      )}
      {isPickerDisplay && (
        <div className="position-absolute color-picker-popover m-5 pt-2" style={{ zIndex: 99 }}>
          <SketchPicker color={color} onChange={handleChange} />
        </div>
      )}
      {/* </div>
        </div>
      </div> */}
    </>
  );
};
